import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './index.css';

import { register } from './serviceWorkerRegistration';
import Dexie from 'dexie';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

register({
  onUpdate: async () => {
    try {
      const db = new Dexie('JNC_AQ_Database');
      await db.open();
      const atascados = await db.table('PendingSync')
        .filter(r =>
          r.type === 'POST_OBSERVACIONES_ELEMENTOS' &&
          !r.synced &&
          r.data?.Id != null
        )
        .toArray();
      for (const r of atascados) {
        await db.table('PendingSync').delete(r.id);
      }
    } catch (e) {
      console.error('Error limpiando PendingSync en update:', e);
    }
    window.location.reload();
  }
});